import type { TourFrame, TourStep } from '@carboncopyco/types';

export const getParentFrame = (frames: TourFrame[], searchStep: TourStep) => {
  if (frames?.length === 0 || !searchStep) {
    return;
  }
  return frames?.find((frame) =>
    frame.steps?.some((step) => step?.stepId === searchStep?.stepId)
  );
};

/**
 * Returns uuid  file service url  this can be used as a unique id of the frame in a given seesion
 * example: https://file-service.carboncopy.co/api/v1/files/60f7d-4b7d-4e7d-8b7d-4e7d8b7d4e7
 */
export const getFrameIndetifier = (frame: TourFrame) => {
  if (frame?.frameDataUrl) {
    return frame.frameDataUrl.split('/').at(-1);
  }
};
